module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/prev-57de7779c4f3fad73fbdc54b18a7a38f.svg";